function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function formatMoney (cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || '€{{amount}}';

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    let parts = number.split('.'),
        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
  }

  let value = '';
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
  }
    
  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value).replace(',00', '');
  } else {
    return formatString.replace(placeholderRegex, value).replace('.00', '');
  }

};

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
    this.qtyUnitPrice();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.qtyUnitPrice();
      this.input.dispatchEvent(this.changeEvent);
    }
  }

  qtyUnitPrice() {
    const qtyInUnit = this.querySelector('#qty-in-unit');
    if (qtyInUnit) {
      const itemLength = qtyInUnit.dataset.patternSpacing * this.input.value;
      qtyInUnit.innerHTML = itemLength.toFixed(2);
      const productElement = this.closest('.product');
      if (productElement) {
        const prodPrice = productElement.querySelector(".meter-price .ProductMeta__Price.Price--compareAt"),
            prodPriceContainer = productElement.querySelector("#ComparePrice"),
            salePrice = productElement.querySelector(".meter-price .ProductMeta__Price.Price"),
            salePriceContainer = productElement.querySelector("#ProductPrice"),
            getProdPrice = parseFloat(prodPrice ? prodPrice.innerHTML : 0).toFixed(2).replace(/\D/g,''),
            getSalePrice = parseFloat(salePrice ? salePrice.innerHTML : 0).toFixed(2).replace(/\D/g,''),
            quantity = this.input.value,
            totalPrice = quantity * getProdPrice;
        if (getProdPrice && getProdPrice > 0) {
          prodPriceContainer.innerHTML = formatMoney(totalPrice);
        }
        const totalSalePrice = quantity * getSalePrice;
        salePriceContainer.innerHTML = formatMoney(totalSalePrice);
      }
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`,  'header-menu-open');
    if (summaryElement.classList.contains('certificates-info__open-wrapper')) {
      document.querySelector('.product__info-container').classList.add('extra-z-index');
    }
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`,  'header-menu-open');
    if (this.classList.contains('certificates-info__wrapper')) {
      document.querySelector('.product__info-container').classList.remove('extra-z-index');
    }
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    if (detailsElement) {
      const parentMenuElement = detailsElement.closest('.submenu-open');
      parentMenuElement && parentMenuElement.classList.remove('submenu-open');
      detailsElement.classList.remove('menu-opening');
      detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
      removeTrapFocus(detailsElement.querySelector('summary'));
      this.closeAnimation(detailsElement);
    }
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    
  }

  bindEvents() {
    super.bindEvents();
    const self = this;

    this.querySelectorAll('.menu-drawer__close').forEach(close => close.addEventListener('click', function() {
      self.header.querySelector('summary').click();
    }));

    new SV.HoverIntent(this.querySelectorAll('.list-menu__item, .menu-drawer__utility-links'), {
      onEnter: function(targetItem) {
        if (targetItem.closest('[data-desktop-secondary]')) {
          const openNavSelector = targetItem.closest('[data-desktop-secondary]').getAttribute('data-desktop-secondary');
          self.closeSubDrawer('tertiary');
          self.openSubDrawer('secondary', openNavSelector);
        } else {
          self.closeSubDrawer('tertiary');
          self.closeSubDrawer('secondary');
        }
        self.openImageDrawer(targetItem);
      },
      onExit: function(targetItem) {
      },
      exitDelay: 400,
      interval: 100,
      sensitivity: 7,
    });

    // Open secondary desktop navigation
    this.querySelectorAll('summary[data-desktop-secondary]').forEach(summary => summary.addEventListener('click', function(event) {
      const openNavSelector = event.target.closest('[data-desktop-secondary]').getAttribute('data-desktop-secondary');
      self.openSubDrawer('secondary', openNavSelector);
      self.openImageDrawer(event.target);

      const selectedNavList = document.querySelector(`.desktop-secondary-drawer__wrapper[data-desktop-secondary="${openNavSelector}"]`);
      const elementToFocus = selectedNavList.querySelector('[data-item-level="2"]');
      trapFocus(selectedNavList, elementToFocus);
    }));

    new SV.HoverIntent(this.querySelectorAll('.desktop-secondary-drawer__list__button[data-desktop-tertiary], .desktop-secondary-drawer__list__link'), {
      onEnter: function(targetItem) {
        if (targetItem.closest('[data-desktop-tertiary]')) {
          const openNavSelector = targetItem.closest('[data-desktop-tertiary]').getAttribute('data-desktop-tertiary');
          self.openSubDrawer('tertiary', openNavSelector);
        } else {
          self.closeSubDrawer('tertiary');
        }
        self.openImageDrawer(targetItem);
      },
      onExit: function(targetItem) {
      },
      exitDelay: 400,
      interval: 100,
      sensitivity: 7,
    });

    // Open tertiary desktop navigation
    this.querySelectorAll('.desktop-secondary-drawer__list__button[data-desktop-tertiary]').forEach(button => button.addEventListener('click', function(event) {
      const openNavSelector = event.target.closest('[data-desktop-tertiary]').getAttribute('data-desktop-tertiary');
      self.openSubDrawer('tertiary', openNavSelector);
      self.openImageDrawer(event.target);
      const selectedNavList = document.querySelector(`.desktop-tertiary-drawer__wrapper[data-desktop-tertiary="${openNavSelector}"]`);
      const elementToFocus = selectedNavList.querySelector('[data-item-level="3"]');
      trapFocus(selectedNavList, elementToFocus);
    }));

    new SV.HoverIntent(this.querySelectorAll('.desktop-tertiary-drawer__list__link'), {
      onEnter: function(targetItem) {
        self.openImageDrawer(targetItem);
      },
      onExit: function(targetItem) {
      },
      exitDelay: 400,
      interval: 100,
      sensitivity: 7,
    });

    // Open tertiary desktop image
    this.querySelectorAll('.desktop-tertiary-drawer__list__link').forEach(button => button.addEventListener('click', function(event) {
      self.openImageDrawer(event.target);
    }));
  }

  openSubDrawer(level, navListSelector) {
    const drawer = document.querySelector(`.desktop-${level}-drawer`);
    drawer.classList.add('is-open');

    const allNavLists = drawer.querySelectorAll(`.desktop-${level}-drawer__wrapper`);
    allNavLists.forEach(function(navList) {
      navList.classList.remove('is-open');
    });

    const selectedNavList = drawer.querySelector(`.desktop-${level}-drawer__wrapper[data-desktop-${level}="${navListSelector}"]`);
    selectedNavList.classList.add('is-open');
  }

  closeSubDrawer(level) {
    const drawer = document.querySelector(`.desktop-${level}-drawer`);
    drawer.classList.remove('is-open');
    const allNavLists = drawer.querySelectorAll(`.desktop-${level}-drawer__wrapper`);
    allNavLists.forEach(function(navList) {
      navList.classList.remove('is-open');
    });
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().top - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`,  'header-menu-open');
  }

  openImageDrawer(target) {
    const imageContainer = document.querySelector('.desktop-drawer-images');
    const imageSelector = target.getAttribute('data-drawer-image-item');
    const level = target.getAttribute('data-item-level');
    const selectedImage = imageContainer.querySelector(`[data-drawer-image="${imageSelector}"][data-nav-item-level="${level}"]`);

    this.closeImageDrawer();
    imageContainer.classList.add(target.getAttribute('data-drawer-image-level'));

    if (selectedImage) {
      imageContainer.classList.add('is-open');
      selectedImage.classList.add('selected');
    } else {
      if (level == '2') {
        const backupItemSelector = target.closest('[data-desktop-secondary]').getAttribute('data-desktop-secondary');
        const backupItem = document.querySelector(`.list-menu__item[data-drawer-image-item="${backupItemSelector}"]`);
        if (backupItem) {
          this.openImageDrawer(backupItem);
        }
      } 

      if (level == '3') {
        const backupItemSelector = target.closest('[data-desktop-tertiary]').getAttribute('data-desktop-tertiary');
        const backupItem = document.querySelector(`.desktop-secondary-drawer__list__button[data-drawer-image-item="${backupItemSelector}"]`);
        if (backupItem) {
          this.openImageDrawer(backupItem);
        }
      } 
      
    }
  }

  closeImageDrawer() {
    const imageContainer = document.querySelector('.desktop-drawer-images');
    imageContainer.classList.remove('is-open', 'first-level', 'second-level', 'third-level');
    imageContainer.querySelectorAll('img').forEach((img) => {
      img.classList.remove('selected');
    });
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    this.closeSubDrawer('tertiary');
    this.closeSubDrawer('secondary');
    this.closeImageDrawer();
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.currentIndex = -1;
    this.dots = this.querySelector('.slider-dots');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.dots) {
      this.dots.classList.remove('hidden');
      const newIndex = this.currentPage - 1;
      const visibleDots = this.dots.querySelectorAll('.slider-dots__dot:not(.hidden)');
      if (visibleDots && visibleDots.length < 2) {
        this.dots.classList.add('hidden');
      } else {
        const selectedDot = visibleDots[newIndex];
        visibleDots.forEach((dot) => dot.classList.remove('is-active'));
        if (selectedDot) {
          selectedDot.classList.add('is-active');
        }
      }
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    // Set the height of the gallery on slide change
    if (this.hasAttribute('data-set-height')) {
      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)

      if (vw < 750) {
        const atSnappingPoint = this.slider.scrollLeft % this.slider.offsetWidth === 0;
        const timeOut = atSnappingPoint ? 0 : 150;
        const self = this;

        clearTimeout(this.slider.scrollTimeout);
        this.slider.scrollTimeout = setTimeout(function() {
          const newIndex = self.currentPage - 1;
          if (self.currentIndex != newIndex) {
            self.currentIndex = newIndex;
            const allVisibleSlides = Array.from(self.sliderItems).filter(element => element.clientWidth > 0);
            const currentSlide = allVisibleSlides[self.currentIndex];
            if (currentSlide) {
              const currentSlideHeight = currentSlide.querySelector('modal-opener').offsetHeight;
              self.slider.style.height = `${currentSlideHeight}px`;
            }
          }
        }, timeOut);
      } else {
        this.slider.style.height = 'auto';
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', (event) => this.onVariantChange(event));
    this.quantitySelectorWithUnit();
  }

  onVariantChange(event) {
    if (event.target.closest('.mobile-size-picker')) {
      this.updateOptionsMobile();
    } else {
      this.updateOptions();
    }
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.quantitySelectorWithUnit();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptionsMobile() {
    let sizeOptions = Array.from(this.querySelectorAll('select'), (select) => select.value);
    const fieldsets = Array.from(this.querySelectorAll('fieldset.color-input'));
    let colorOptions = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    this.options = [ ...sizeOptions, ...colorOptions];
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    // if size variant does not exist, pick the first variant of same color
    if (!this.currentVariant) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return variant.option2 === this.options[0];
      });
    }

    if (!this.currentVariant) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return variant.option2 === this.options[1];
      });
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const additionalMedia = document.querySelectorAll('[data-media-skus]');
    let foundSku = false;
    additionalMedia.forEach(media => {
      const mediaSkusArray = media.dataset.mediaSkus.split('; ').map(sku => sku.split('_')[0]);
      if (mediaSkusArray.includes(this.currentVariant.sku)) {
        media.classList.remove('hidden');
        foundSku = true;
      } else {
        media.classList.add('hidden');
      }
    });

    if (!foundSku) {
      additionalMedia[0].classList.remove('hidden');
    }

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')

        const ctaPriceDestination = document.querySelector('.product-cta-sticky__price');
        const ctaPriceSource = html.querySelector('.product-cta-sticky__price');

        const ctaButtonDestination = document.querySelector('.product-cta-sticky__button');
        const ctaButtonSource = html.querySelector('.product-cta-sticky__button');

        const variantInfoDestination = document.querySelector('.product__info-container');
        const variantInfoSource = html.querySelector('.product__info-container');

        const priceDestination = document.getElementById(`price-${this.dataset.section}`);
        const priceSource = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        
        const variantPickerDestination = document.querySelector('variant-radios');
        const variantPickerSource = html.querySelector('variant-radios');
        
        const inventoryQuantityDestination = document.querySelector('.inventory-quantity');
        const inventoryQuantitySource = html.querySelector('.inventory-quantity');

        const quantityAndBuyButtonsDestination = document.querySelector('.quantity-and-buy-buttons');
        const quantityAndBuyButtonsSource = html.querySelector('.quantity-and-buy-buttons');
        
        const storeAvailabilityDestination = document.querySelector('.product-stores');
        const storeAvailabilitySource = html.querySelector('.product-stores');

        const productTypeDestination = document.querySelector('.product .product__info-wrapper .product-type');
        const productTypeSource = html.querySelector('.product .product__info-wrapper .product-type');

        const bisTriggerDestination = document.querySelector('.bis-trigger-container');
        const bisTriggerSource = html.querySelector('.bis-trigger-container');
        
        const productCodeDestination = document.querySelector('.product-code');
        const productCodeSource = html.querySelector('.product-code');

        if (html.querySelector('.unit-prices')) {
          this.quantitySelectorWithUnit();
        };

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        const disable = this.currentVariant && this.currentVariant.available ? false : true
        this.toggleAddButton(disable, window.variantStrings.soldOut);

        if (ctaPriceSource && ctaPriceDestination) ctaPriceDestination.innerHTML = ctaPriceSource.innerHTML;
        if (ctaButtonSource && ctaButtonDestination) ctaButtonDestination.innerHTML = ctaButtonSource.innerHTML;
        // if (variantInfoSource && variantInfoDestination) variantInfoDestination.innerHTML = variantInfoSource.innerHTML;

        if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
        if (inventoryQuantitySource && inventoryQuantityDestination) inventoryQuantityDestination.innerHTML = inventoryQuantitySource.innerHTML;
        if (quantityAndBuyButtonsSource && quantityAndBuyButtonsDestination) quantityAndBuyButtonsDestination.innerHTML = quantityAndBuyButtonsSource.innerHTML;
        if (storeAvailabilitySource && storeAvailabilityDestination) storeAvailabilityDestination.innerHTML = storeAvailabilitySource.innerHTML;
        if (variantPickerSource && variantPickerDestination) variantPickerDestination.innerHTML = variantPickerSource.innerHTML;
        if (productTypeSource && productTypeDestination) productTypeDestination.innerHTML = productTypeSource.innerHTML;
        if (bisTriggerSource && bisTriggerDestination) bisTriggerDestination.innerHTML = bisTriggerSource.innerHTML;
        if (productCodeSource && productCodeDestination) productCodeDestination.innerHTML = productCodeSource.innerHTML;

        // Update sticky button visibility based on hide_buy_button metafield
        const stickyButtonContainer = document.querySelector('.product-cta-sticky');
        const stickyButtonContainerSource = html.querySelector('.product-cta-sticky');
        if (stickyButtonContainer && stickyButtonContainerSource) {
          const hideBuyButton = stickyButtonContainerSource.dataset.hideBuyButton;
          if (hideBuyButton === 'true') {
            stickyButtonContainer.style.display = 'none';
          } else {
            stickyButtonContainer.style.display = '';
          }
          stickyButtonContainer.dataset.hideBuyButton = hideBuyButton;
        }

        // Update main buy buttons visibility based on hide_buy_button metafield
        const mainBuyButtonContainer = document.querySelector('.quantity-and-buy-buttons');
        const mainBuyButtonContainerSource = html.querySelector('.quantity-and-buy-buttons');
        if (mainBuyButtonContainer && mainBuyButtonContainerSource) {
          const hideBuyButton = mainBuyButtonContainerSource.dataset.hideBuyButton;
          if (hideBuyButton === 'true') {
            mainBuyButtonContainer.style.display = 'none';
          } else {
            mainBuyButtonContainer.style.display = '';
          }
          mainBuyButtonContainer.dataset.hideBuyButton = hideBuyButton;
        }

        document.dispatchEvent(new Event('product:render-info'));
        document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: this.currentVariant } }))
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  quantitySelectorWithUnit() {
    const qtyInUnit = document.querySelector('#qty-in-unit');
    if (qtyInUnit) {
      const quantity = qtyInUnit.closest('.quantity-and-buy-buttons').querySelector('.quantity__input');
      if (quantity) {
        const itemLength = qtyInUnit.dataset.patternSpacing * quantity.value;
        qtyInUnit.innerHTML = itemLength.toFixed(2);
        const productElement = this.closest('.product');
        if (productElement) {
          const prodPrice = productElement.querySelector(".meter-price .ProductMeta__Price.Price--compareAt"),
              prodPriceContainer = productElement.querySelector("#ComparePrice"),
              salePrice = productElement.querySelector(".meter-price .ProductMeta__Price.Price"),
              salePriceContainer = productElement.querySelector("#ProductPrice"),
              getProdPrice = parseFloat(prodPrice ? prodPrice.innerHTML : 0).toFixed(2).replace(/\D/g,''),
              getSalePrice = parseFloat(salePrice ? salePrice.innerHTML : 0).toFixed(2).replace(/\D/g,''),
              totalPrice = quantity.value * getProdPrice;
          if (getProdPrice && getProdPrice > 0) {
              prodPriceContainer.innerHTML = formatMoney(totalPrice);
            }
          const totalSalePrice = quantity.value * getSalePrice;
          if (totalSalePrice && totalSalePrice > 0) {
            salePriceContainer.innerHTML = formatMoney(totalSalePrice);
          }
        }
      }
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    let fieldsets = Array.from(this.querySelectorAll('fieldset')).reverse();
    if (fieldsets && fieldsets.length < 1) {
      let sizeOptions = Array.from(this.querySelectorAll('select'), (select) => select.value);
      this.options = [...sizeOptions];
    } else {

      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// Make elements sticky inside containers (and also scrollable)
const stickyElements = document.querySelectorAll('.is-sticky')
if (stickyElements.length) {
  for (let i = 0; i < stickyElements.length; i += 1) {
    const stickyElement = stickyElements[i];
    stickyElement.lastKnownY = window.scrollY;
    stickyElement.currentTop = 0;
    window.addEventListener('scroll', function() {
      const bounds = stickyElement.getBoundingClientRect(),
      maxTop = bounds.top + window.scrollY - stickyElement.offsetTop,
      minTop = stickyElement.clientHeight - window.innerHeight;

      if (window.scrollY < stickyElement.lastKnownY) {
        stickyElement.currentTop -= window.scrollY - stickyElement.lastKnownY;
      } else {
        stickyElement.currentTop += stickyElement.lastKnownY - window.scrollY;
      }

      stickyElement.currentTop = Math.ceil(Math.min(Math.max(stickyElement.currentTop, -minTop), maxTop, 0));
      stickyElement.lastKnownY = window.scrollY;

      stickyElement.style.top = stickyElement.currentTop + 'px';
    });
  }
}

const collectionLayoutSwitchers = document.querySelectorAll('[data-action="change-layout-mode"]');

if (collectionLayoutSwitchers) {
  collectionLayoutSwitchers.forEach(element => {
    element.addEventListener('click', (event) => {
      var layoutType = event.target.getAttribute('data-grid-type'),
          newCount = parseInt(event.target.getAttribute('data-count'));

      // Otherwise we detect the mode, and change all classes
      var productList = document.querySelector('#product-grid');

      if (productList) {
        var previousCount = parseInt(productList.getAttribute('data-' + layoutType + '-count'));

        if (previousCount === newCount) {
          return; // Nothing has changed so we just return to avoid reflow
        }
        productList.classList.forEach(classItem => {
          if (classItem.includes('col-desktop')) {
            productList.classList.remove(classItem)
          }
        });
        
        productList.classList.add('grid--' + newCount + '-col-desktop');
        productList.setAttribute('data-' + layoutType + '-count', newCount);
      }

      collectionLayoutSwitchers.forEach(element => {
        element.classList.remove('is-active')
      });
      event.target.classList.add('is-active');


      // In order to prevent reflow and provide better user experience, we save into cart attributes (those are removed before the checkout
      // is submitted) the user choices so they are preserved on page reload, without the need to use JavaScript

      fetch(routes.cart_url + '/update.js', {
        body: JSON.stringify({
          attributes: { ['collection_' + layoutType + '_items_per_row']: newCount }
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
        }
      });
    });
  });
}

// const headerSearch = document.querySelector('.header__search');
// let searchResultsLoadStarted = false;

// if (headerSearch) {
//   headerSearch.addEventListener('click', fetchTrending, false)
// }

// let cachedProductRecommendationsHtml = '';
// let cachedCategoryRecommendationsHtml = '';

// function fetchTrending() {
//   if (!searchResultsLoadStarted) {
//     searchResultsLoadStarted = true;
//     const data = {
//       "recordQueries": [
//         {
//           "id": "productsTrending",
//           "typeOfRequest": "RECS_TRENDING",
//           "settings": {
//             "query": {},
//             "personalisation": {
//               "enablePersonalisation": false
//             },
//             "context": {
//               "recentObjects": []
//             },
//             "typeOfRecords": [
//               "KLEVU_PRODUCT"
//             ],
//             "limit": 7,
//             "fields": ["id", "name", "url", "typeOfRecord", "image"]
//           }
//         },
//         {
//           "id": "categoriesTrending",
//           "typeOfRequest": "RECS_TRENDING",
//           "settings": {
//             "query": {},
//             "personalisation": {
//               "enablePersonalisation": false
//             },
//             "context": {
//               "recentObjects": []
//             },
//             "typeOfRecords": [
//               "KLEVU_CATEGORY"
//             ],
//             "limit": 3,
//             "fields": [
//               "url", 
//               "name"
//             ]
//           }
//         }
//       ],
//       "context": {
//         "apiKeys": [
//           window.klevuApiToken
//         ]
//       }
//     };

//     fetch("https://eucs6.ksearchnet.com/cs/v2/search", {
//       "method": "POST",
//       "headers": {
//         "Accept": "application/json"
//       },
//       "body": JSON.stringify(data)
//     })
//     .then(response => response.json())
//     .then((json) => {
//       const productRecommendations = json.queryResults[0].records;
//       const productRecommendationsContainer = document.querySelector('.product-results');

//       const productRecommendationsHtml = productRecommendations.map(item => 
//         `<div class="card-wrapper product-card-wrapper card-wrapper--sold-out">
//           <div class="card card--product card--media" style="--ratio-percent: 142.85714285714286%;">
//             <div class="card__inner ratio">
//               <div class="card__media">
//               ${item.imageUrl ? `<div class="media media--transparent media--hover-effect">
        
//               <img src="${item.imageUrl}"
//                 alt="${item.name}" class="motion-reduce" loading="lazy" width="100" height="120">
//             </div>` : ''}
//               </div>
//             </div>
//             <div class="card__content">
//               <div class="card__information">
//                 <h3 class="card__heading">
//                   <a href="/products/${item.handle}" class="full-unstyled-link">
//                     ${item.name}
//                   </a>
//                 </h3>
//               </div>
//             </div>
//           </div>
//         </div>`
//       ).join('');
//       productRecommendationsContainer.innerHTML = productRecommendationsHtml;
//       cachedProductRecommendationsHtml = productRecommendationsHtml;

//       const categoryRecommendations = json.queryResults[1].records;
//       const categoryRecommendationsContainer = document.querySelector('.category-results');
//       const categoryRecommendationsHtml = categoryRecommendations.map(item => 
//         `<div class="category-suggestion">
//             <a href="${item.url}" class="full-unstyled-link">${item.name}</a>
//         </div>`
//       ).join('');
//       categoryRecommendationsContainer.innerHTML = categoryRecommendationsHtml;
//       cachedCategoryRecommendationsHtml = categoryRecommendationsHtml;
//     })
//     .catch(err => {
//       console.error(err);
//     });
//   }
// }

// function debounce(func, timeout = 300){
//   let timer;
//   return (...args) => {
//     clearTimeout(timer);
//     timer = setTimeout(() => { func.apply(this, args); }, timeout);
//   };
// }


const headerSearch = document.querySelector('.header__search');
console.log('headerSearch:', headerSearch);
let searchResultsLoadStarted = false;

if (headerSearch) {
  headerSearch.addEventListener('click', fetchTrending, false)
}

document.addEventListener('DOMContentLoaded', (event) => {
  // fetchTrending();
})

let cachedProductRecommendationsHtml = document.querySelector('.product-results');
let cachedCategoryRecommendationsHtml = document.querySelector('.category-results');

function fetchTrending() {
  if (!searchResultsLoadStarted) {
    searchResultsLoadStarted = true;
    var data = {
      recommendationType: "most-viewed",
      limit: 7
    };

    const formBody = Object.keys(data).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])).join('&');

    fetch("https://services.mybcapps.com/discovery/recommend?shop=vallila-fi.myshopify.com&recommendationType=newest-arrivals", {
      "method": "POST",
      "headers": {
        "Accept": "*/*",
        "Content-Type": "application/x-www-form-urlencoded"
      },
      "body": formBody
    })
    .then(response => response.json())
    .then((json) => {
      const productRecommendations = json.products;
      const productRecommendationsContainer = document.querySelector('.product-results');

      const productRecommendationsHtml = productRecommendations.map(item => {
        console.log('productRecommendationsHtml ~ item:', item);
        let productImage = null;
        if (item.variants && item.variants.length > 0 && item.variants[0].image) {
          productImage = item.variants[0].image;
        } else if (item.images && item.images[1]) {
          productImage = item.images[1];
        }
        return `<div class="card-wrapper product-card-wrapper card-wrapper--sold-out">
        <div class="card card--product card--media" style="--ratio-percent: 142.85714285714286%;">
          <div class="card__inner ratio">
            <div class="card__media">
            ${productImage ? `<div class="media media--transparent media--hover-effect">
      
            <img src="${productImage}"
              alt="${item.title}" class="motion-reduce" loading="lazy" width="100" height="120">
          </div>` : ''}
            </div>
          </div>
          <div class="card__content">
            <div class="card__information">
              <h3 class="card__heading">
                <a href="/products/${item.handle}" class="full-unstyled-link">
                  ${item.title}
                </a>
              </h3>
            </div>
          </div>
        </div>
      </div>`
      }).join('');
      productRecommendationsContainer.innerHTML = productRecommendationsHtml;
    })
    .catch(err => {
      console.error(err);
    });
  }
}

function debounce(func, timeout = 300){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

const headerSearchInput = document.querySelector('#header-search');

function search() {
  const productResultsContainer = document.querySelector('.suggestions-results--products');
  const categoryResultsContainer = document.querySelector('.suggestions-results--categories');

  if (!headerSearchInput.value) {
    const fullProductsHtml = `<div class="suggestions-heading">
    <span>${window.searchStrings.productSuggestions}</span>
    </div>
    <div class="product-results">
      ${cachedProductRecommendationsHtml.innerHTML}
    </div>
    `;
    productResultsContainer.innerHTML = fullProductsHtml;

    const fullCategoriesHtml = `<div class="suggestions-heading">
        ${window.searchStrings.popularCategories}
      </div>
      <div class="category-results">
        ${cachedCategoryRecommendationsHtml.innerHTML}
      </div>
    `;
    categoryResultsContainer.innerHTML = fullCategoriesHtml;
  } else {

    fetch("https://services.mybcapps.com/bc-sf-filter/search/suggest?shop=vallila-fi.myshopify.com&product_limit=7&q=" + headerSearchInput.value)
    .then(response => {
      return response.json();
    }).then((json) => {
      const productsResults = json.products;
      console.log(productsResults);
      if (!productsResults || productsResults.length === 0) {
        // FIX 
        const fullProductsHtml = `<div class="suggestions-heading">
          <span>${window.searchStrings.productSuggestions}</span>
        </div>
        <div class="product-results">
          ${cachedProductRecommendationsHtml.innerHTML}
        </div>
        `;
        productResultsContainer.innerHTML = fullProductsHtml;
      } else {
        const productResultsHtml = productsResults.map(item => {
          console.log('productResultsHtml ~ item:', item);
          let productImage = null;
          if (item.variants && item.variants.length > 0 && item.variants[0].image) {
            productImage = item.variants[0].image;
          } else if (item.images && item.images[1]) {
            productImage = item.images[1];
          } else if (item.images && item.images[0]) {
            productImage = item.images[0];
          }
          return `<div class="card-wrapper product-card-wrapper card-wrapper--sold-out">
            <div class="card card--product card--media" style="--ratio-percent: 142.85714285714286%;">
              <div class="card__inner ratio">
                <div class="card__media">
                ${productImage ? `<div class="media media--transparent media--hover-effect">
          
                <img src="${productImage}"
                  alt="${item.title}" class="motion-reduce" loading="lazy" width="100" height="120">
              </div>` : ''}
                </div>
              </div>
              <div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading">
                    <a href="/products/${item.handle}" class="full-unstyled-link">
                      ${item.title}
                    </a>
                  </h3>
                </div>
              </div>
            </div>
          </div>`
      }).join('');

        const fullProductsHtml = `<div class="suggestions-heading">
          <span>${window.searchStrings.products}</span>
          ${json.total_product > 7 ? `<a href="${routes.search_url}?q=${headerSearchInput.value}" class="full-unstyled-link see-all-results-link see-all-results-link-top">${window.searchStrings.seeAllProducts}</a>` : ''}
        </div>
        <div class="product-results">
          ${productResultsHtml}
        </div>
        ${json.total_product > 7 ? `<a href="${routes.search_url}?q=${headerSearchInput.value}" class="full-unstyled-link see-all-results-link see-all-results-link-bottom">${window.searchStrings.seeAllProducts}</a>` : ''}
        `;

        productResultsContainer.innerHTML = fullProductsHtml;
      }

      const categoryResults = json.collections;
      if (!categoryResults || productsResults.length === 0) {
        const fullCategoriesHtml = `<div class="suggestions-heading">
            ${window.searchStrings.popularCategories}
          </div>
          <div class="category-results">
            ${cachedCategoryRecommendationsHtml.innerHTML}
          </div>
        `;
        categoryResultsContainer.innerHTML = fullCategoriesHtml;
      } else {
        const categoryResultsHtml = categoryResults.map(item => 
          `<div class="category-suggestion">
              <a href="/collections/${item.handle}" class="full-unstyled-link">${item.title}</a>
          </div>`
        ).join('');

        const fullCategoriesHtml = `<div class="suggestions-heading">
            ${window.searchStrings.categories}
          </div>
          <div class="category-results">
            ${categoryResultsHtml}
          </div>
        `;
        categoryResultsContainer.innerHTML = fullCategoriesHtml;
      }
    })
    .catch(err => {
      console.error(err);
    });
  }
}

const processHeaderInput = debounce(() => search());

headerSearchInput.addEventListener('keyup', processHeaderInput)

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const searchTerm = urlParams.get('q')

if (searchTerm) {

  fetch("https://services.mybcapps.com/bc-sf-filter/search?shop=vallila-fi.myshopify.com&limit=70&q=" + searchTerm)
  .then(response => {
    return response.json();
  }).then((json) => {
    const productsResults = json.products;
    const productResultsContainer = document.getElementById('search-product-grid');
    const productResultsHtml = productsResults.map(item => {
      return item.variants.map(variant => {
      console.log('productResultsHtml ~ variant:', variant);
      let productImage = null;
        if (variant && variant.image) {
          productImage = variant.image;
        } else if (item.images && item.images[1]) {
          productImage = item.images[1];
        };
        return `<li class="grid__item">
        <div class="card-wrapper product-card-wrapper card-wrapper--sold-out">
          <div class="card card--product card--media" style="--ratio-percent: 142.85714285714286%;">
            <div class="card__inner ratio">
              <div class="card__media">
                ${productImage ? `<div class="media media--transparent media--hover-effect">
                  <img src="${productImage}" alt="${item.title}" class="motion-reduce" width="800" height="538">
                ` : ''}
                </div>
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading">
                  <a href="/products/${item.handle}?variant=${variant.id}" class="full-unstyled-link">
                    ${item.title}
                  </a>
                </h3>
                <div class="card-information">
                  <div class="price${!variant.available ? ' price--sold-out' : ''}${parseInt(variant.price) < parseInt(variant.compare_at_price) ? ' price--on-sale' : ''}">
                    <div class="price__container">
                      <div class="price__regular">
                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                        <span class="price-item price-item--regular">
                          ${variant.price.replace('.', ',')} €
                        </span>
                      </div>
                      <div class="price__sale">
                        <span class="visually-hidden visually-hidden--inline">Sale price</span>
                        <span class="price-item price-item--sale price-item--last">
                          ${variant.price.replace('.', ',')} €
                        </span>
                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                        <span>
                          <s class="price-item price-item--regular">
                            ${variant.compare_at_price ? variant.compare_at_price.replace('.', ',') : variant.price.replace('.', ',')} €
                          </s>
                        </span>
                        <div class="price-row">
                          <span class="price-row__label">Regular price</span>
                          <s class="price-row__price">
                            ${variant.compare_at_price ? variant.compare_at_price.replace('.', ',') : variant.price.replace('.', ',')} €
                          </s>
                          <span class="price-row__percentage">-%
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>`
      }).join('');
    }).join('');

    if (productResultsHtml) {
      productResultsContainer.innerHTML = productResultsHtml;
    } else {
      productResultsContainer.innerHTML = `<div class="no-results-container"><p role="status">${window.searchStrings.noResults}</p></div>`;
    }
  })
  .catch(err => {
    console.error(err);
  });
}


// Product sticky cta
const productStickyCTA = document.querySelectorAll('.product-cta-sticky')
if (productStickyCTA.length) {
  for (let i = 0; i < productStickyCTA.length; i += 1) {
    const productStickyCTAElement = productStickyCTA[i];
    let isVisible = false;
    window.addEventListener('scroll', function() {
      const windowTop = window.scrollY;
      const windowBottom = windowTop + window.innerHeight;

      const start = document.querySelector('.quantity-and-buy-buttons').offsetTop + document.querySelector('.quantity-and-buy-buttons').offsetHeight;
      const end = document.querySelector('#shopify-section-footer').offsetTop;

      if (windowTop >= start && windowBottom < end && isVisible == false) {
        productStickyCTAElement.classList.add('is-visible');
        isVisible = true;
      }

      if (windowTop < start || windowBottom > end && isVisible == true) {
        productStickyCTAElement.classList.remove('is-visible');
        isVisible = false;
      }
    });
  }
  document.addEventListener('click', (e) => {
    const target = e.target.closest(".product-cta-sticky .product-form__submit");

    if(target){
      document.querySelector('.quantity-and-buy-buttons .product-form__submit').click();
    }
  });

  document.addEventListener('product-form:add-start', function () {
    const submitButton = document.querySelector('.product-cta-sticky .product-form__submit');
    submitButton.setAttribute('aria-disabled', true);
    submitButton.classList.add('loading');
    submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  });

  document.addEventListener('product-form:add-end', function () {
    const submitButton = document.querySelector('.product-cta-sticky .product-form__submit');
    submitButton.classList.remove('loading');
    submitButton.removeAttribute('aria-disabled');
    submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
  });
}